import React, { Component } from "react";
import nota from '../Global/nota.guidelines.json';
import styled from 'styled-components';

import Type from '../Global/Typography.js';
import NanoFlex from '../Global/NanoFlex.js';

const multiple = nota.global.multiple;


//const boxHeight = multiple * 4; // 32
const boxHeight = multiple * 3; // 24

const StyledMainInputWheel = styled.div`
    user-select: none;
    user-drag: none;
    -webkit-user-drag: none;
    margin: 40px 0;
    position: relative;
    width:  ${multiple * 4 + 'px'}; /* 32px */;
    .click {
        height:${boxHeight / 2 + 'px'};
        z-index: 1;
        cursor: pointer;
    }
    .topClick{
        position: relative;
        top: ${boxHeight / 2 + 'px'};
    }
    .bottomClick{
        position: relative;
        bottom: ${boxHeight / 2 + 'px'};
    }
     .layerActive {
        height:${boxHeight + 'px'};
        width: 100%;
        background:${nota.color.main.default};
        position: absolute;
        top: 29px;
        z-index: -1;
    }

`;

const StyledInputWheel = styled.div`
    position: relative;
    height: ${multiple * 7 + 'px'}; /* 56x */;
    overflow: hidden;

`;

const StyledWheelPosition = styled.div`
    will-change: transform;
    transition: ${props => `transform ${Math.abs(props.offset) / 100 + .3}s`};
    transform: ${props => `translateY(${props.position}px)`};
    padding-top: 16px;

    .wheel-box {
        height: ${boxHeight + 'px'};
        opacity: .5;
    }
    .active {
        opacity: 1;
        cursor: grab;
    }
`;

class InputWheel extends Component {

  constructor(props) {
      super(props)
      this.state = {
          position: this.props.selected ? -(this.props.selected) * boxHeight : 0,
          selectedIndex: this.props.selected ? this.props.selected : 0
      };
      this.offset = 0;
      this.dragging = false;
  }

  componentDidUpdate(prevProps, prevState) {
      if (prevProps.data !== this.props.data) {
          const { selectedIndex } = this.state;
          const lastIndex = this.props.data.length - 1;

          if (selectedIndex > lastIndex) {
              this.setState({
                  position: 0,
                  selectedIndex: 0
              });

              if (this.props.onDateChange) this.props.onDateChange(this.props.type, 0, this.props.data);
          };
      };

      if (prevProps.selected !== this.props.selected) {
          this.setState({
              position: -(this.props.selected) * boxHeight,
              selectedIndex: this.props.selected
          });

          if (this.props.onDateChange) this.props.onDateChange(this.props.type, this.props.selected, this.props.data);
      };

      if (prevState.selectedIndex !== this.state.selectedIndex) {
          if (this.props.onDateChange) this.props.onDateChange(this.props.type, this.state.selectedIndex, this.props.data);
      };
  }

  onMouseDown = (e) => {
      this.previousY = e.touches ? e.touches[0].clientY : e.clientY;
      this.dragging = true;

      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
      document.addEventListener('touchmove', this.onMouseMove);
      document.addEventListener('touchend', this.onMouseUp);
  }

  onMouseMove = (e) => {
      let clientY = e.touches ? e.touches[0].clientY : e.clientY;

      this.offset = clientY - this.previousY;

      let maxPosition = -this.props.data.length * boxHeight;
      let position = this.state.position + this.offset;

      this.setState({ position: Math.max(maxPosition, Math.min(boxHeight, position)) });

      this.previousY = e.touches ? e.touches[0].clientY : e.clientY;
  }

  onMouseUp = () => {
      let maxPosition = -(this.props.data.length - 1) * boxHeight;
      let rounderPosition = Math.round((this.state.position + this.offset * 5) / boxHeight) * boxHeight;
      let finalPosition = Math.max(maxPosition, Math.min(0, rounderPosition));

      const newSelectedIndex = finalPosition === 0 ? 0 : -finalPosition / boxHeight;

      this.dragging = false;

      const { position, selectedIndex } = this.state;
      if (position !== finalPosition || selectedIndex !== newSelectedIndex) {
          this.setState({
            position: finalPosition,
            selectedIndex: newSelectedIndex
          });

          if (this.props.onDateChange) this.props.onDateChange(this.props.type, newSelectedIndex, this.props.data);
      };

      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
      document.removeEventListener('touchmove', this.onMouseMove);
      document.removeEventListener('touchend', this.onMouseUp);
  }

  goUpAndDown = (up = true) => {
      const min = 0;
      const max = this.props.data.length - 1;
      const { position, selectedIndex } = this.state;

      const shouldUpdate = (up ? selectedIndex !== min : true) && (!up ? selectedIndex !== max : true);

      if (shouldUpdate) {
          this.setState({
              position: up ? position + boxHeight : position - boxHeight,
              selectedIndex: up ? selectedIndex - 1 : selectedIndex + 1
          });
      };
  }

  render() {
      return (
          <StyledMainInputWheel>

              <NanoFlex className='click topClick' onClick={() => this.goUpAndDown(true)} />

              <StyledInputWheel>
                  <StyledWheelPosition
                      offset={this.offset}
                      position={this.state.position}
                      onMouseDown={this.onMouseDown}
                      onTouchStart={this.onMouseDown}>
                      {this.props.data.map((value, index) =>
                          <NanoFlex className={this.state.selectedIndex === index ? 'wheel-box active' : 'wheel-box'} key={value}>
                                  {this.state.selectedIndex === index
                                  ? <Type.p white><b>{value}</b></Type.p>
                                  : <Type.p>{value}</Type.p>}
                          </NanoFlex>
                      )}
                  </StyledWheelPosition>

              </StyledInputWheel>

              <div className="layerActive"></div>

              <NanoFlex className='click bottomClick' onClick={() => this.goUpAndDown(false)} />

        </StyledMainInputWheel>
      );
  };
};

export default InputWheel;

// --- // Documentation // --- //
/*
import InputWheel from './../Nano/InputWheel.js';

<InputWheel
    data={ [] }
    type='month'
    selected={0}
    onDateChange={(type, value, dataList) => console.log('InputWheel', type, value, dataList)}
/>
*/
